import _ from 'lodash';
import React from 'react';

import Button from 'components/Button';
import {default as DateRangeFilter} from 'components/Filters/DateRangeFilter';

import TreeSelect from 'components/Filters/TreeSelect';
import SelectFilter from 'components/Filters/SelectFilter';
import BookingFilter from 'components/Filters/BookingFilter';
import AllocationTypeFilter from 'components/Filters/AllocationTypeFilter';
import TccwFloorFilter from 'components/Filters/TccwFloorFilter';

import {fetchCurrentBookingOptions as sdkFetchCurrentBookingOptions} from 'sdk/rooms';

import {ROOM_OCCUPANCY_STATUSES, ROOM_PURPOSES_TYPES} from 'ducks/allocations';

import './styles.css';

interface PassedProps {
  locationRef: string;
  setFilter: (field: string, value: any) => void;
  clearFilters: () => void;
  getFilters: any;
  roomTypeFilters: any;
  roomTypes: any;
  rooms: any;
  floors: Array<any>;
}

class AvailabilityFilters extends React.Component<PassedProps> {
  state = {
    searchValue: ''
  };
  bookingSelectElement: any = null;

  componentDidMount() {
    if (_.isNull(this.props.getFilters().dummy)) {
      this.props.setFilter('dummy', false);
    }
  }

  fetchBookingOptions = search => {
    const {locationRef} = this.props;

    return sdkFetchCurrentBookingOptions({locationRef, search});
  };

  clearAvailabilityFilters = () => {
    if (this.bookingSelectElement) {
      this.bookingSelectElement.onChange(null);
    }

    this.props.clearFilters();
  };

  render() {
    const {setFilter, roomTypeFilters, rooms, locationRef, floors} = this.props;
    const filters: any = this.props.getFilters();

    const roomTypeData = roomTypeFilters.map(roomTypeGroup => ({
      label: roomTypeGroup.name,
      data: roomTypeGroup.roomTypes.map(roomType => ({
        label: roomType.name,
        key: roomType.ref
      }))
    }));

    const floorOptions = floors.map(floor => ({label: floor, value: floor}));
    const roomsData = rooms.map(room => ({
      label: room.roomNumber,
      value: room.id
    }));

    return (
      <div className="AvailabilityFilters colab-row-space-between">
        <div className="AvailabilityFilters__filterBox colab-sidepadding-2">
          <DateRangeFilter
            label="Availability"
            fieldName="availability"
            classNameForTesting="availability"
            start={filters.startDate}
            end={filters.endDate}
            startFieldName="startDate"
            endFieldName="endDate"
            onChange={(dateField, date) => setFilter(dateField, date)}
          />
          <SelectFilter
            label="Room Purpose Type"
            classNameForTesting="roomPurposeType"
            data={ROOM_PURPOSES_TYPES}
            value={filters.roomPurposes}
            onChange={roomPurposes => {
              setFilter('roomPurposes', roomPurposes);
            }}
          />
          <TreeSelect
            label="Room Type"
            classNameForTesting="roomType"
            data={roomTypeData}
            value={filters.roomTypes}
            onFilterChange={roomTypes => {
              setFilter('roomTypes', roomTypes);
            }}
          />
          <SelectFilter
            label="Room Status"
            classNameForTesting="roomStatus"
            data={ROOM_OCCUPANCY_STATUSES}
            value={filters.roomStatuses}
            onChange={roomStatuses => {
              setFilter('roomStatuses', roomStatuses);
            }}
          />
          <SelectFilter
            label="Room"
            classNameForTesting="room"
            data={roomsData}
            value={filters.rooms}
            onChange={rooms => setFilter('rooms', rooms)}
          />
          {locationRef !== 'tccw' && (
            <SelectFilter
              label="Floor"
              classNameForTesting="floor"
              data={floorOptions}
              value={filters.floors.join(',')}
              onChange={value =>
                setFilter('floors', value.filter(x => x !== ''))
              }
            />
          )}
          {locationRef === 'tccw' && (
            <TccwFloorFilter
              onChange={value =>
                setFilter('floors', value.filter(x => x !== ''))
              }
              filters={filters}
              floors={floors}
            />
          )}
          <BookingFilter
            fetchSdk={this.fetchBookingOptions}
            bookingSelectRef={el => (this.bookingSelectElement = el)}
            onChange={this.props.setFilter}
            value={filters.booking}
          />
          <AllocationTypeFilter
            value={filters.dummy}
            classNameForTesting="allocationType"
            onChange={value => this.props.setFilter('dummy', value)}
          />
        </div>
        <div>
          <Button clear onClick={this.clearAvailabilityFilters}>
            Clear all filters
          </Button>
        </div>
      </div>
    );
  }
}

export default AvailabilityFilters;
